<template>
  <loading v-if="loading" />

  <modal v-if="modal.display" @close="modal.display = false">
    <template #header>{{ modal.header }}</template>
    <template #body>{{ modal.body }}</template>
  </modal>

  <debug v-if="debug">{{ params }}</debug>
</template>

<script>
import liff from "@line/liff";
import api from "../api/index";

export default {
  data() {
    return {
      debug: eval(process.env.VUE_APP_DEBUG),
      liffIds: JSON.parse(process.env.VUE_APP_LIFFID)[
        process.env.VUE_APP_STAGE
      ],
      jwts: JSON.parse(process.env.VUE_APP_JWT),
      loading: true,
      modal: {},
      params: null,
      liffId: null
    };
  },
  mounted() {
    //處理傳入的參數
    //:jwt/:platform/:page/:paramA.../:paramN
    this.params = this.$route.params;

    //將不確定的參數改為都改為 falsly
    this.params.dept =
      typeof this.params.dept !== "string" || this.params.dept === ""
        ? false
        : this.params.dept;
    this.params.doctor =
      typeof this.params.doctor !== "string" || this.params.doctor === ""
        ? false
        : this.params.doctor;

    //處理不同平台
    switch (this.params.platform) {
      case "develop": //開發模式
        api.auth
          .auth({
            platform: "develop"
          })
          .then(data => {
            console.log("Auth response:", data);
            //會員資料存入Vue store
            this.$store.dispatch("login", {
              jwt: data.jwt,
              platform: this.params.platform,
              info: data.member,
              params: this.params
            });
            this.$router.replace(`/${this.params.page}`);
          })
          .catch(error => {
            this.modal = {
              display: true,
              header: "Develop auth error.",
              body: error.message
            };
          });
        break;

      case "web":
        if (this.params.patientNo !== undefined) {
          //醫師台點擊問診單
          this.params.page = "FirstVisitForm";
        }
        api.auth
          .auth({
            platform: "web"
          })
          .then(data => {
            this.$store.dispatch("login", {
              jwt: data.jwt,
              platform: this.params.platform,
              info: { patientNo: null },
              params: this.params
            });
            this.$router.replace(`/${this.params.page}`);
          })
          .catch(error => {
            this.modal = {
              display: true,
              header: "Web auth error.",
              body: error.message
            };
          });
        break;
      case "musoon":
      case "pad":
        if (this.params.patientNo !== undefined) {
          //醫師台點擊問診單
          this.params.page = "FirstVisitForm";
        }
        this.$store.dispatch("login", {
          jwt: this.jwts[this.params.platform],
          platform: this.params.platform,
          info: { patientNo: null },
          params: this.params
        });
        this.$router.replace(`/${this.params.page}`);
        break;

      case "line":
        //設定不同LIFF ID
        switch (true) {
          case this.params.qrcode !== undefined:
            this.params.page = "CheckInQRCode"; //for secondary URL redirect
            this.liffId = this.liffIds[this.params.page]; //看診報到
            break;
          case this.liffIds[this.params.page] !== undefined:
            this.liffId = this.liffIds[this.params.page];
            break;
          default:
            this.liffId = this.liffIds["HomePage"]; //首頁
            break;
        } //switch LIFF id
        // alert(
        //   `Init: ${this.liffId}\n${p}\nQRCode:${
        //     this.params.qrcode
        //   }\n${d.toString()}`
        // );

        liff
          .init({ liffId: this.liffId })
          .then(() => {
            if (liff.isLoggedIn()) {
              api.auth
                .auth({
                  platform: "line",
                  lineToken: liff.getIDToken()
                })
                .then(data => {
                  console.log(data);
                  this.$store.dispatch("login", {
                    jwt: data.jwt,
                    platform: this.params.platform,
                    info: data.member,
                    params: this.params
                  });
                  this.$router.replace(`/${this.params.page}`);
                })
                .catch(error => {
                  this.modal = {
                    display: true,
                    header: "LINE異常訊息",
                    body: error.message
                  };
                });
            } else {
              liff.login();
            }
          })
          .catch(error => {
            this.modal = {
              display: true,
              header: "LINE初始化異常",
              body: error.message
            };
          });
        break;

      case "ios":
      case "android":
        break;
    } //switch platform
  } //mounted
};
</script>
